var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly Two-tone Chat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M9.05958 1.00013C7.6776 0.992157 6.31704 1.34114 5.11006 2.01315C3.90309 2.68517 2.89075 3.65732 2.17134 4.83529C1.45193 6.01327 1.0499 7.35696 1.00435 8.73585C0.95881 10.1147 1.2713 11.482 1.91142 12.7047L2.07166 13.0165C2.13748 13.1379 2.17847 13.2712 2.19223 13.4086C2.20598 13.546 2.19226 13.6848 2.15182 13.8168C1.92281 14.4247 1.73134 15.046 1.57857 15.6772C1.57857 15.9972 1.67027 16.1806 2.01465 16.1724C2.62142 16.0378 3.21894 15.8647 3.80363 15.6541C4.05646 15.5846 4.32527 15.6006 4.56806 15.6995C4.79169 15.806 5.23895 16.0805 5.25684 16.0805C6.33021 16.6441 7.51772 16.9571 8.72987 16.9959C9.94201 17.0347 11.1471 16.7983 12.2545 16.3046C13.3618 15.8109 14.3425 15.0727 15.1226 14.1457C15.9026 13.2186 16.4617 12.1269 16.7577 10.9528C17.0537 9.77876 17.0788 8.55296 16.8313 7.36775C16.5838 6.18255 16.07 5.06886 15.3287 4.11068C14.5874 3.1525 13.6379 2.37482 12.5518 1.8362C11.4656 1.29758 10.2712 1.01206 9.05845 1.00122L9.05958 1.00013Z",
    stroke: "#5A40A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-5",
    d: "M5.23689 9.38287C5.44808 9.38287 5.61929 9.21196 5.61929 9.00113C5.61929 8.7903 5.44808 8.61938 5.23689 8.61938C5.0257 8.61938 4.85449 8.7903 4.85449 9.00113C4.85449 9.21196 5.0257 9.38287 5.23689 9.38287Z",
    fill: "#5A40A4",
    stroke: "#5A40A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-6",
    d: "M9.05916 9.38287C9.27035 9.38287 9.44156 9.21196 9.44156 9.00113C9.44156 8.7903 9.27035 8.61938 9.05916 8.61938C8.84796 8.61938 8.67676 8.7903 8.67676 9.00113C8.67676 9.21196 8.84796 9.38287 9.05916 9.38287Z",
    fill: "#5A40A4",
    stroke: "#5A40A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-7",
    d: "M12.8824 9.38287C13.0936 9.38287 13.2648 9.21196 13.2648 9.00113C13.2648 8.7903 13.0936 8.61938 12.8824 8.61938C12.6712 8.61938 12.5 8.7903 12.5 9.00113C12.5 9.21196 12.6712 9.38287 12.8824 9.38287Z",
    fill: "#5A40A4",
    stroke: "#5A40A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.789364009f329e7816dff0197344f3cb.svg";
export { ForwardRef as ReactComponent };